var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-header"},[_c('div',{staticClass:"contenedor-texto container"},[_c('div',{staticClass:"i-title"},[_vm._v(_vm._s(_vm.ministryName))]),_c('span',{staticClass:"i-desc"},[_vm._v("Lista de Servicios del Ministerio")])])])}
var staticRenderFns = []

export { render, staticRenderFns }